$(document).ready(function () {
  $('.main-header nav [data-menu=1]').click(function () {
    let parentUl = $(this).closest('ul');
    $(parentUl).find('.shown').removeClass('shown');
    let ul = $(this).parent().children('ul');
    $(ul).addClass('shown');
    $(this).addClass('shown');
  });

  $('.main-header nav').on('mouseleave', function () {
    $(this).find('.shown').removeClass('shown');
  });

  $('.main-header nav [data-menu-back]').click(function () {
    $(this).parent().parent().find('.shown').removeClass('shown');
  });
});